<template>
    <div v-if="isActive" :id="tab" :aria-labelledby="buttonId" role="tabpanel" tabindex="0">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ['tab', 'activeTab'],
    computed: {
        isActive() {
            return this.tab === this.activeTab;
        },
        buttonId() {
            return this.tab + '-button'
        },
    },
};
</script>
